module.exports = __webpack_public_path__ + "static/img/two.33e04fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partTimePackage/two.png
// module id = uA2a
// module chunks = 1